import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { NotificationProvider } from './contexts/NotificationContext.jsx'
import { PermissionProvider } from './contexts/PermissionContext.jsx'
import { ThemeProvider } from './contexts/ThemeContext.jsx'
import { DirectionProvider } from './contexts/DirectionContext.jsx'
import { SidebarProvider } from './contexts/SidebarContext.jsx'
// Initialize i18next once at startup — must come BEFORE DirectionProvider
// because DirectionProvider calls useTranslation() which requires i18next ready.
import './i18n/index.js'
import './styles/index.css'

// Create QueryClient with optimized settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* Theme + Direction sit at the outermost layer because they manipulate
        document.documentElement attributes that affect everything below. */}
    <ThemeProvider>
      <DirectionProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <PermissionProvider>
                <NotificationProvider>
                  <SidebarProvider>
                    <App />
                  </SidebarProvider>
                  {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                </NotificationProvider>
              </PermissionProvider>
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </DirectionProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
